"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var react_use_1 = require("react-use");
var highcharts_1 = __importDefault(require("highcharts"));
var highcharts_react_official_1 = __importDefault(require("highcharts-react-official"));
var utils_1 = require("./utils");
var lodash_1 = require("lodash");
/* eslint-disable */
highcharts_1.default.wrap(SVGElement.prototype, 'setAttribute', function (proceed) {
    var _this = this;
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    this;
    if (args[0] !== 'style')
        return proceed.apply(this, args);
    if (typeof args[1] === 'string') {
        args[1]
            .split(';')
            .filter(Boolean) // remove empty strings
            .forEach(function (cssRuleString) {
            var _a = cssRuleString.split(':'), ruleKey = _a[0], ruleValue = _a[1];
            switch (ruleKey) {
                case 'font-family':
                    _this.style.fontFamily = ruleValue;
                    break;
                case 'font-size':
                    _this.style.fontSize = ruleValue;
                    break;
                case 'font-weight':
                    _this.style.fontWeight = ruleValue;
                    break;
                case 'fill':
                    _this.style.fill = ruleValue;
                    break;
                case 'cursor':
                    _this.style.cursor = ruleValue;
                    break;
                case 'color':
                    _this.style.color = ruleValue;
                    break;
                case 'display':
                    _this.style.display = ruleValue;
                    break;
                default:
                    console.warn("Could not set style " + ruleKey + ", add me to the list");
                    break;
            }
        });
    }
    else {
        console.warn("Could not set style " + args[1] + ", not a string");
    }
});
var Chart = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, height = _a.height, width = _a.width, margin = _a.margin, marginTop = _a.marginTop, marginRight = _a.marginRight, marginBottom = _a.marginBottom, marginLeft = _a.marginLeft, options = _a.options, props = __rest(_a, ["title", "subtitle", "height", "width", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "options"]);
    var chartRef = react_2.useRef(null);
    var _b = react_use_1.useMeasure(), ref = _b[0], _c = _b[1], refWidth = _c.width, refHeight = _c.height;
    react_2.useEffect(function () {
        if (chartRef.current && chartRef.current.container.current) {
            ref(chartRef.current.container.current);
        }
    }, [chartRef, ref]);
    react_use_1.useDebounce(function () {
        var _a;
        (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.chart.reflow();
    }, 500, [refWidth, refHeight]);
    var baseOptions = react_2.useMemo(function () { return utils_1.buildOptions({
        title: title,
        subtitle: subtitle,
        height: height,
        width: width,
        margin: margin,
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft,
    }); }, [title, subtitle, height, width, margin, marginTop, marginRight, marginBottom, marginLeft]);
    var mergedOptions = react_2.useMemo(function () { return lodash_1.merge({}, baseOptions, options); }, [baseOptions, options]);
    return (react_1.jsx(highcharts_react_official_1.default, __assign({ highcharts: highcharts_1.default, containerProps: { style: { height: '100%', width: '100%' } }, options: mergedOptions, ref: chartRef }, props)));
};
exports.default = Chart;
